import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../colorVars';
import { useAlertsStore } from '../../../../../../../stores/websocketStore/_alertsStore';
import { Body3 } from '../../../../../../atomic/text/Text';

export const FilterStatus = observer(({ alertId }) => {
  let filterStatus = '✅ ';
  let both = false;
  const alertStore = useAlertsStore();
  const sortingDetails = alertStore.alertSortingStore[alertId] ?? null;

  if (sortingDetails) {
    const filterArr = Object.keys(sortingDetails.filters);
    if (filterArr.length > 0) {
      for (const filter of filterArr) {
        if (!sortingDetails.filters[filter].status) {
          filterStatus = '❌ ';
          break;
        }
      }
      if (filterArr.includes('FTFC_FILTER')) {
        if (
          sortingDetails.filters.FTFC_FILTER.status &&
          sortingDetails.filters.FTFC_FILTER.details.bothDirections
        ) {
          both = true;
        }
      }
    }
  }
  return (
    <td>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Body3
          color={
            filterStatus === 'N/A'
              ? colors.lightGrey
              : filterStatus === '✅ '
              ? colors.green
              : colors.red
          }
          fontWeight={500}
        >
          {both
            ? `${filterStatus}\u00A0 [${sortingDetails.filters.FTFC_FILTER.details.direction}]`
            : filterStatus}
        </Body3>
      </div>
    </td>
  );
});

FilterStatus.propTypes = {
  alertId: PropTypes.any,
};
